import type { DataTableFilter } from '@/components/data-table/data-table.interface'

import type { BillingUsageEntry } from './billing.interface'

export const formatUsageDateTime = (date: Date): string => {
  const d = new Date(date)
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const formatUsageCurrency = (amount: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(amount)

export const usageTypeFilterList: DataTableFilter[] = [
  {
    id: 'type',
    label: 'Type',
    type: 'multi-select',
    optionList: [
      { label: 'LLM', value: 'llm' },
      { label: 'Tool', value: 'tool' },
      { label: 'Other', value: 'other' },
    ],
  },
]

export const getUsageRowId = (entry: BillingUsageEntry): string => entry.id
